import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

const eventDataSelector = createSelector(
  (state) => state.event,
  (event) => {
    const {allPerformers = []} = event;
    const {webURI} = allPerformers && allPerformers.length && allPerformers[0];

    return {
      webURI,
    };
  }
);

const controller = new Controller({
  namespace: 'noListings',
  mapStateToProps(state = /* istanbul ignore next */ {}) {
    return {
      ...eventDataSelector(state),
    };
  },
});

export default controller;
